import { normal } from 'components/calls/styles/fonts';
import styled, { css } from 'styled-components';
import { getImageUrl, media } from 'utils';

export const ParticipantsRow = styled.div<{ rows: number; showParticipants: boolean }>`
  width: 100%;
  max-height: ${(props) => Math.ceil(100 / props.rows) + '%'};
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
  justify-items: center;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 4px;

  ${(props) =>
    props.showParticipants &&
    css`
      ${media.desktop`
      grid-template-columns: 1fr;
    `}
      width: 100%;
      padding: 10px;
    `}

  &:last-child {
    margin-bottom: 0px;
  }

  ${media.tablet`
    gap:1rem;
    grid-template-columns: 1fr;
    padding: 10px;
  `}

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #413f43;
  }
`;

export const ParticipantView = styled.div<{
  rows: number;
  width: number;
  height: number;
  isLocal?: boolean;
  showParticipants?: boolean;
}>`
  width: ${(props) =>
    Math.min(((props.height - 184) / props.rows) * (16 / 9), (props.width - 32) / 2) + 'px'};
  position: relative;
  z-index: 10;
  margin: 5px;

  &:first-child {
    margin-right: 4px;
  }

  &:before {
    display: block;
    content: '';
    padding-top: 56.25%; /*What you want the height to be in relation to the width*/
  }

  ${media.tablet`
    width: 85%;
  `}

  ${media.mobile`
    width: 100%;
  `}

  ${(props) =>
    props.showParticipants &&
    css`
      width: 90%;
    `}
`;

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 15px;
  object-fit: cover;
`;

export const Wrapper = styled.div<{
  showParticipants?: boolean;
}>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  max-height: calc(100vh - 64px - 88px);

  > ${ParticipantView} {
    width: 90%;
  }

  @media (min-width: 1920px) {
    > ${ParticipantView} {
      width: 65%;
    }
  }
`;
export const ParticipantInfo = styled.div`
  margin: 0px 0px 5px 5px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 4px 6px;
  background-color: rgba(33, 34, 66, 0.8);
  ${normal};
  color: white;

  ${media.mobile`
    font-size:10px
  `}
`;

export const ParticipantOverlay = styled.div<{ fillBlack?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  ${(props) =>
    props.fillBlack
      ? css`
          background-color: black;
        `
      : ''};
`;

export const Avatar = styled.div<{ url?: string }>`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  /* background-image: url(${(props) =>
    props.url ? props.url : getImageUrl('/icons/icon-avatar.svg')}); */
`;

export const ParticipantMutedIcon = styled.div`
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: ${getImageUrl('/icons/icon-audio-off.svg')};
  margin-right: 4px;

  ${media.mobile`
    width:12px;
    height:12px;
    background-size:10px;
  `}
`;
